import { startCase } from 'lodash-es';
import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { PERSON } from '../constants';
import { PERSON_TYPE } from '../constants/stringConstants';
import { Section } from './index';
import type { Application } from './Types';

/**
 * Class to model People Section data returned by API
 */
export default class PeopleSection extends Section {
  personTypeLabel: string;

  constructor(args, personType: PERSON_TYPE) {
    super(args);

    this.personTypeLabel = startCase(personType);

    const personFields = [
      new Field({
        fieldName: `${personType}_isEnabled`,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.FIRST_NAME}`,
        dataType: FieldDataType.string,
        enteredValue: '',
        validation: ValidationType.NameValidator,
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.LAST_NAME}`,
        dataType: FieldDataType.string,
        enteredValue: '',
        validation: ValidationType.NameValidator,
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.EMAIL_ADDRESS}`,
        dataType: FieldDataType.string,
        enteredValue: '',
        validation: ValidationType.EmailValidator,
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.MAILING_ADDRESS}`,
        dataType: FieldDataType.string,
        enteredValue: '',
        validation: ValidationType.PropertyAddressValidator,
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.PHONE_NUMBER}`,
        dataType: FieldDataType.string,
        enteredValue: '',
        validation: ValidationType.PhoneValidator,
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.APPLICATION_ID}`,
        dataType: FieldDataType.string,
        enteredValue: '',
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.APPLICATION_STATUS}`,
        dataType: FieldDataType.string,
        enteredValue: '',
      }),
      new Field({
        fieldName: `${personType}_${PERSON.FIELD_NAME.RENTAL_PROTECTION_STATUS}`,
        dataType: FieldDataType.string,
        enteredValue: '',
      }),
    ];

    this.setIndexedFieldTypes(personFields);
  }

  getApplication = (applicationList: Array<Application>): Application | undefined => {
    const indexedFieldGroupApplicationId = this.getIndexedFieldGroup(
      `${PERSON_TYPE.TENANT}_${PERSON.FIELD_NAME.APPLICATION_ID}`,
    );

    if (!indexedFieldGroupApplicationId || indexedFieldGroupApplicationId.length === 0) {
      return undefined;
    }
    const applicationId = indexedFieldGroupApplicationId[0].enteredValue;

    return applicationList.find((application) => application.applicationId === applicationId);
  };
}
